module.exports = __webpack_public_path__ + "media/images/arrow-l@2x-755ef194bc88addf9b5383beb20c4e66.png";